import digitalOffice from './digital-office-i18n-en.json';

export const digitalOfficeResource = { ...digitalOffice };
